import { createSlice } from '@reduxjs/toolkit';
import {
  fetchTimeSeries,
  fetchGroupBySender,
  fetchGroupByOutreach,
  fetchAllOutreaches,
} from './actions';

const initialState = {
  timeSeries: {
    isLoading: true,
    data: {},
    filter: { changed: false, recruiters: [] },
  },
  timeRange: {
    to: null,
    from: null,
    label: 'Last 7 days',
    id: '7d',
    defaultInterval: 'day',
    intervalOptions: ['day', 'week', 'month'],
  },
  groupBySender: {
    isLoading: true,
    data: [],
    page: 1,
    filter: { changed: false, senders: [] },
  },
  groupByOutreach: {
    isLoading: true,
    data: [],
    page: 1,
    filter: { changed: false, ids: [] },
  },
  allOutreaches: {
    isLoading: true,
    data: [],
  },
};

const { reducer, actions } = createSlice({
  name: 'dashboardOutreach',
  initialState,

  reducers: {
    applyTimeRange: (state, { payload }) => {
      const { to, from, label, id, defaultInterval, intervalOptions } = payload;
      state.timeRange.to = to;
      state.timeRange.from = from;
      state.timeRange.label = label;
      state.timeRange.id = id;
      state.timeRange.defaultInterval = defaultInterval;
      state.timeRange.intervalOptions = intervalOptions;
    },

    applyGroupByOutreachFilter: (state, { payload }) => {
      const { type, value } = payload;
      state.groupByOutreach.filter[type] = value;
      state.groupByOutreach.filter.changed = true;
    },

    clearGroupByOutreachFilter: (state, { payload }) => {
      const { type, isMulti = false } = payload;
      state.groupByOutreach.filter[type] = isMulti ? [] : null;
      state.groupByOutreach.filter.changed = false;
    },

    applyTimeSeriesFilter: (state, { payload }) => {
      const { type, value } = payload;
      state.timeSeries.filter[type] = value;
      state.timeSeries.filter.changed = true;
    },

    clearTimeSeriesFilter: (state, { payload }) => {
      const { type, isMulti = false } = payload;
      state.timeSeries.filter[type] = isMulti ? [] : null;
      state.timeSeries.filter.changed = false;
    },

    applyGroupByOutreachPage: (state, { payload }) => {
      const { type, value } = payload;
      state.groupByOutreach[type] = value;
    },

    clearGroupByOutreachPage: (state, { payload }) => {
      const { type } = payload;
      state.groupByOutreach[type] = 1;
    },

    applyGroupBySenderFilter: (state, { payload }) => {
      const { type, value } = payload;
      state.groupBySender.filter[type] = value;
      state.groupBySender.filter.changed = true;
    },

    clearGroupBySenderFilter: (state, { payload }) => {
      const { type, isMulti = false } = payload;
      state.groupBySender.filter[type] = isMulti ? [] : null;
      state.groupBySender.filter.changed = false;
    },

    applyGroupBySenderPage: (state, { payload }) => {
      const { type, value } = payload;
      state.groupBySender[type] = value;
    },

    clearGroupBySenderPage: (state, { payload }) => {
      const { type } = payload;
      state.groupBySender[type] = 1;
    },
  },

  extraReducers: {
    [fetchTimeSeries.pending]: (state) => {
      state.timeSeries.isLoading = true;
    },

    [fetchTimeSeries.fulfilled]: (state, { payload }) => {
      state.timeSeries.data = payload?.data || {};
      state.timeSeries.isLoading = false;
    },

    [fetchGroupBySender.pending]: (state) => {
      state.groupBySender.isLoading = true;
    },

    [fetchGroupBySender.fulfilled]: (state, { payload }) => {
      state.groupBySender.data = payload || {};
      state.groupBySender.isLoading = false;
    },

    [fetchGroupByOutreach.pending]: (state) => {
      state.groupByOutreach.isLoading = true;
    },

    [fetchGroupByOutreach.fulfilled]: (state, { payload }) => {
      state.groupByOutreach.data = payload || {};
      state.groupByOutreach.isLoading = false;
    },

    [fetchAllOutreaches.pending]: (state) => {
      state.allOutreaches.isLoading = true;
    },

    [fetchAllOutreaches.fulfilled]: (state, { payload }) => {
      state.allOutreaches.data = payload || {};
      state.allOutreaches.isLoading = false;
    },
  },
});

export const {
  applyTimeRange,
  applyTimeSeriesFilter,
  clearTimeSeriesFilter,
  applyGroupByOutreachFilter,
  clearGroupByOutreachFilter,
  applyGroupByOutreachPage,
  clearGroupByOutreachPage,
  applyGroupBySenderFilter,
  clearGroupBySenderFilter,
  applyGroupBySenderPage,
  clearGroupBySenderPage,
} = actions;

export default reducer;
